<nav class="col-md-12 top-bar" [class.top-outlet]="false"
  [class.top-user]="true">
  <div class="col-md-12 row wrap">
    <div class="col trending-nav">
      <span >
        <ul>
          <!-- Todays Deals Top Navigation -->
          <li class="mobile-nav-item">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"
              class="todays-s _today-deals">
              <path class="_icon-fill"
                d="m5.65288161 22.1989497c1.00630522.837552 2.17361928 1.4358035 3.42143776 1.7149875.12075663.0398834.20126105-.1196503.12075663-.1994171-2.696898-2.592423-.40252209-6.2218151.08050442-6.9397168.4830265-.7577852 1.69059278-2.1138218 1.61008838-4.1079933 0-.1994172.201261-.3589509.3622699-.2393006 1.5295839.7976686 2.5761413 2.5525395 2.8579068 3.988343.4427743-.4387177.6037831-1.116736.6037831-1.7149875 0-.1994171.2415133-.3589509.4427743-.1994171 1.4490795 1.3161531 3.9447165 5.7830973-.0805044 9.2928391-.0805044.0797669 0 .2393006.0805044.1994172 1.2075663-.3190675 2.3748803-.8774355 3.3811856-1.6352207 6.56111-5.105079 2.2943759-14.15861757-.4830265-17.14987481-.3622699-.35895086-1.0063053-.11965029-1.0063053.3988343-.0402522 1.07685261-.3622698 2.27335551-1.2075662 3.0710241-.6440354-2.71207323-2.7774024-6.10216477-5.8365703-7.6177351-.40252211-.19941715-.88554862.11965029-.84529641.55836802.08050442 3.70915897-2.33462812 6.38134878-4.42774299 9.45237289-1.85160161 2.7519566-3.05916787 7.8171522.92580081 11.1274769z" />
            </svg>
            <span>
              todayDeal's
            </span>
            <span class="trending-nav-bage hide-mobile">12</span>
          </li>
        </ul>
      </span>


    </div>
  </div>
</nav>

